import { ZMessage } from '@zoryn/components/message'

const message = (msg, type) => {
  return ZMessage({
    message: msg,
    type: type || 'info',
    customClass: '_fc-message-tip',
  })
}

const errorMessage = (msg) => {
  return message(msg, 'error')
}

export default errorMessage

export { message }
